import {
  Document,
  Page,
  View,
  Text,
  Font,
  Image,
  StyleSheet
} from "@react-pdf/renderer";

import iconBrasaoNiteroi from '../assets/img/brasao_niteroi.png';
import fesaudeLogo from '../assets/img/fesaude-logo.png'
import { formatDate } from "../helpers/formatDate";

const styles = StyleSheet.create({
  header: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'row',
      marginTop: 20,
  },
  img: {
      width: 45,
  },
  imgRight: {
      width: 45,
  },
  divider: {
      width: '1px',
      backgroundColor: '#000011',
      height: '100%',
      marginHorizontal: '15px'
  },
  titleContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    marginTop: 20,
    marginBottom: 8,
    paddingVertical: 5,
    paddingHorizontal: 100,
    backgroundColor: '#064674',
  },
  title: {
      color: '#fff',
      fontFamily: 'Helvetica-Bold',
      fontSize: 11,
      textAlign: 'center',
  },
  hell: {
      alignItems: 'center',
      justifyContent: 'center',
      border: '0.7px solid #000',
      fontFamily: 'Helvetica-Bold',
      height: 25,
      backgroundColor: '#f5f5f5'
      // paddingHorizontal: 6,
  },
    hellLeft: {
      alignItems: 'flex-start',
      paddingLeft: 15,
      justifyContent: 'center',
      border: '0.7px solid #000',
      fontFamily: 'Helvetica-Bold',
      height: 25,
      backgroundColor: '#f5f5f5'
      // paddingHorizontal: 6,
  },
  hellText: {
      fontSize: 7, 
      textAlign: 'center',
  },
  indice: {
    border: '0.7px solid #000', 
    height: 27,
    backgroundColor: '#fff',
    fontSize: 7, 
    alignItems: "center", 
    justifyContent: 'center',
    textAlign: 'center'
  },
  preenchimento: {
    border: '0.7px solid #000', 
    height: 27,
    backgroundColor: '#fff',
    fontSize: 8, 
    alignItems: "center", 
    justifyContent: 'center',
    textAlign: 'center'
  },
  preenchimentoLeft: {
      border: '0.7px solid #000', 
      height: 27,
      paddingLeft: 15,
      backgroundColor: '#fff',
      fontSize: 6, 
      alignItems: "flex-start", 
      justifyContent: 'center',
      textAlign: 'left'
  },
  preenchimentoLeftText: {
    fontFamily: 'Helvetica-Bold', 
    maxWidth: 320, 
    textOverflow: 'ellipsis'
  },
  dateAndSignature: {
      flexDirection: 'column',
      justifyContent: 'space-between',
      marginHorizontal: 40,
      marginTop: 10,
      marginBottom: 20
  },
  fill: {
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      marginTop: 20,
  },
  fillField: {
      fontSize: 10,
  },
  subtitle: {
    fontSize: 9,
    paddingHorizontal: 50,
    paddingVertical: 10,
    textAlign: 'justify'
  },
  description: {
    flexDirection: 'row',
    marginHorizontal: 50,
    marginVertical: 10
  },
  empregadoInfo: {
    paddingHorizontal: 50,
    marginBottom: 4
  },
  infoContainer: {
    border: '0.7px solid #000', 
    backgroundColor: '#fff',
    fontSize: 7, 
    alignItems: "flex-start", 
    justifyContent: 'flex-start',
    textAlign: 'left',
    padding: 4
  },
  signatureContainer: {
    border: '0.7px solid #000', 
    backgroundColor: '#fff',
    fontSize: 7,
    justifyContent: 'center',
    textAlign: 'left',
    paddingHorizontal: 10,
    paddingVertical: 10,
  },
  signatureRow: {
    flexDirection: 'row',
    alignItems: 'flex-end',
    width: '100%',
    marginBottom: 15,
  },
  signatureRowLast: {
    flexDirection: 'row',
    alignItems: 'flex-end',
    width: '100%',
  },
  signatureLabel: {
    fontSize: 10,
    marginRight: 4,
  },
  signatureLine: {
    borderBottom: '0.7px solid #000',
    flexGrow: 1,
    height: 10,
    marginRight: 12,
  },
  signatureLineSmall: {
    borderBottom: '0.7px solid #000',
    width: 110,
    height: 10,
  },
  infoLine: {
    flexDirection: 'row',
    marginBottom: 4
  },
  infoTextLeft: {
    fontSize: 9,
    width: 300,
  },
  infoTextRight: {
    fontSize: 9,
    width: 190
  },
  infoBold: {
    fontFamily: 'Helvetica-Bold',
  },
  paginacao: { 
    flex: 1,
    zIndex: 10,
    height: '100%',
    position: 'absolute',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'flex-end',
    paddingBottom: 20
  }
})

function PDFSolicitacaoEmergencial({ data, isInsumo }) {
  Font.registerHyphenationCallback(word => {
    if (word?.includes(',')) {
      const part = word.replace(',', '');
      return [part, ',']
    } else {
      const part = [word]
      return part;
    }
  });



  const solicitacaoInfo = {
    numeroChamado: data?.numeroChamado ?? '',
    nome: data?.nome ?? '',
    email: data?.email ?? '',
    unidade: data?.unidade ?? '',
    telefone: data?.telefone ?? '',
    obs: data?.obs ?? '',
    dataSolicitacao: formatDate(data?.createdAt) ?? '',
    insumos: data?.requerimentoInsumos ?? [],
    medicamentos: data?.requerimentoMedicamentos ?? []
  }

  function getItemsList(list) {
    if (!list) return
    
    let paginas = {
      firstPage: [],
      secondPage: [],
      thirdPage: [],
    }

    if (list.length <= 15) {
      return paginas = {
        firstPage: list.slice(0, list.length),
        secondPage: [],
        thirdPage: [],
        totalPages: 1
      }
    }
    
    if (list.length > 15 && list.length <= 45) {
      return paginas = {
        firstPage: list.slice(0, 15),
        secondPage: list.slice(15, 45),
        thirdPage: [],
        totalPages: 2
      }
    }

    if (list.length > 45) {
      return paginas = {
        firstPage: list.slice(0, 15),
        secondPage: list.slice(15, 45),
        thirdPage: list.slice(45, list.length),
        totalPages: 3
      }
    }

    return paginas;
  }

  const finalList = getItemsList(isInsumo ? solicitacaoInfo.insumos : solicitacaoInfo.medicamentos)
  // const finalList = getItemsList(MOCKUP_ITEMS.slice(0, 3))

  function formatDescricao(item) {
    if (!isInsumo) {
      return item?.descricao ?? '';
    }

    return [
      item?.descricao,
      item?.apresentacao,
      item?.qtdApresentacao
    ].filter(Boolean).join(' / ');
  }

  return (
    <Document>
      <Page>
        <View style={styles.header}>
              <Image style={styles.img} src={iconBrasaoNiteroi} />
              <View style={styles.divider} />
              <Image style={styles.imgRight} src={fesaudeLogo} />
          </View>
        <View style={styles.titleContainer}>
            <Text style={styles.title}>SOLICITAÇÃO EMERGENCIAL DE {isInsumo ? "INSUMOS" : "MEDICAMENTOS"} - {solicitacaoInfo.numeroChamado}</Text>
        </View>
        <View style={styles.empregadoInfo}>
          <View style={styles.hell}>
            <Text style={styles.hellText}>INFORMAÇÕES</Text>
          </View>
          <View style={styles.infoContainer}>
            <View style={styles.infoLine}>
              <Text style={styles.infoTextLeft}>
                <Text style={styles.infoBold}>E-mail: </Text>{solicitacaoInfo.email}
              </Text>
              <Text style={styles.infoTextRight}>
                <Text style={styles.infoBold}>Data da solicitação: </Text>{solicitacaoInfo.dataSolicitacao}
              </Text>
            </View>
            <View style={styles.infoLine}>
              <Text style={styles.infoTextLeft}>
                <Text style={styles.infoBold}>Solicitante: </Text>{solicitacaoInfo.nome}
              </Text>
              <Text style={styles.infoTextRight}>
                <Text style={styles.infoBold}>Telefone: </Text>{solicitacaoInfo.telefone ?? ''}
              </Text>
            </View>
            <View style={styles.infoLine}>
              <Text style={styles.infoTextLeft}>
                <Text style={styles.infoBold}>Unidade: </Text>{solicitacaoInfo.unidade}
              </Text>
            </View>
          </View>
        </View>

        <Text style={styles.subtitle}>
          <Text style={styles.infoBold}>Observações: </Text>{solicitacaoInfo.obs}
        </Text>

        <View style={styles.empregadoInfo}>
          <View style={styles.hell}>
            <Text style={styles.hellText}>ASSINATURA DO RESPONSÁVEL PELO RECEBIMENTO DOS ITENS LISTADOS ABAIXO</Text>
          </View>
          <View style={styles.signatureContainer}>
            <View style={styles.signatureRow}>
              <Text style={styles.signatureLabel}>Nome:</Text>
              <View style={styles.signatureLine} />
              <Text style={styles.signatureLabel}>Matrícula:</Text>
              <View style={styles.signatureLineSmall} />
            </View>
            <View style={styles.signatureRowLast}>
              <Text style={styles.signatureLabel}>Assinatura:</Text>
              <View style={styles.signatureLine} />
              <Text style={styles.signatureLabel}>Niterói, ____/____/_______</Text>
            </View>
          </View>
        </View>

        <View style={styles.description}>
          <View>
            <View style={{...styles.hell, width: 20, fontSize: 8}}>
              <Text style={styles.hellText}>#</Text>
            </View>
            { finalList.firstPage.map((item, index) => (
              <View style={styles.indice} key={index}>
                <Text>{index+1}</Text>
              </View>
            ))}
          </View>
          <View>
            <View style={{...styles.hell, width: 58}}>
              <Text style={{...styles.hellText}}>Cód. Interno</Text>
            </View>
            { finalList.firstPage.map((item, index) => (
              <View style={styles.preenchimentoLeft} key={index}>
                <Text style={styles.preenchimentoLeftText}>{item.codigoInterno ? item.codigoInterno : '-'}</Text>
              </View>
            )) }
          </View>
          <View>
            <View style={{...styles.hellLeft, width: 340}}>
              <Text style={{...styles.hellText}}>Descrição / Apresentação / Qtd Apresentação</Text>
            </View>
            { finalList.firstPage.map((item, index) => (
              <View style={styles.preenchimentoLeft} key={index}>
                <Text style={styles.preenchimentoLeftText}>{formatDescricao(item)}</Text>
              </View>
            )) }
          </View>

          <View>
            <View style={{...styles.hell, width: 40}}>
              <Text style={styles.hellText}>Qtd Solicitada</Text>
            </View>
            { finalList.firstPage.map((item, index) => (
              <View style={styles.preenchimento} key={index}>
                <Text>{item.quantidade}</Text>
              </View>
            )) }
          </View>
          <View>
            <View style={{...styles.hell, width: 40}}>
              <Text style={styles.hellText}>Qtd Atendida</Text>
            </View>
            { finalList.firstPage.map((item, index) => (
              <View style={styles.preenchimento} key={index}>
                <Text>{item.quantidadeAtendida}</Text>
              </View>
            )) }
          </View>
        </View>
        <View style={styles.paginacao}>
          <Text style={{ fontSize: 10, textAlign: 'center' }}>1/{finalList.totalPages}</Text>
        </View>
      </Page>
      
      { finalList.secondPage.length > 0 && (
        <Page>
          <View style={{...styles.description, marginTop: 25}}>
            <View>
              <View style={{...styles.hell, width: 20, fontSize: 8}}>
                <Text style={styles.hellText}>#</Text>
              </View>
              { finalList.secondPage.map((item, index) => (
                <View style={styles.indice} key={index}>
                  <Text>{index+16}</Text>
                </View>
              ))}
            </View>
            <View>
              <View style={{...styles.hell, width: 58}}>
                <Text style={{...styles.hellText}}>Cód. Interno</Text>
              </View>
              { finalList.secondPage.map((item, index) => (
                <View style={styles.preenchimentoLeft} key={index}>
                  <Text style={styles.preenchimentoLeftText}>{item.codigoInterno ? item.codigoInterno : '-'}</Text>
                </View>
              )) }
            </View>
            <View>
              <View style={{...styles.hellLeft, width: 340}}>
                <Text style={{...styles.hellText}}>Descrição / Apresentação / Qtd Apresentação</Text>
              </View>
              { finalList.secondPage.map((item, index) => (
                <View style={styles.preenchimentoLeft} key={index}>
                  <Text style={styles.preenchimentoLeftText}>{formatDescricao(item)}</Text>
                </View>
              )) }
            </View>
            <View>
              <View style={{...styles.hellLeft, width: 40}}>
                <Text style={styles.hellText}>Qtd Solicitada</Text>
              </View>
              { finalList.secondPage.map((item, index) => (
                <View style={styles.preenchimento} key={index}>
                  <Text>{item.quantidade}</Text>
                </View>
              )) }
            </View>
            <View>
              <View style={{...styles.hellLeft, width: 40}}>
                <Text style={styles.hellText}>Qtd atendida</Text>
              </View>
              { finalList.secondPage.map((item, index) => (
                <View style={styles.preenchimento} key={index}>
                  <Text>{item.quantidadeAtendida}</Text>
                </View>
              )) }
            </View>
          </View>
          <View style={styles.paginacao}>
            <Text style={{ fontSize: 10, textAlign: 'center' }}>2/{finalList.totalPages}</Text>
          </View>
        </Page>
      ) }

      { finalList.thirdPage.length > 0 && (
        <Page>
          <View style={{...styles.description, marginTop: 25}}>
            <View>
              <View style={{...styles.hell, width: 20, fontSize: 8}}>
                <Text style={styles.hellText}>#</Text>
              </View>
              { finalList.thirdPage.map((item, index) => (
                <View style={styles.indice} key={index}>
                  <Text>{index+46}</Text>
                </View>
              ))}
            </View>
            <View>
              <View style={{...styles.hell, width: 58}}>
                <Text style={{...styles.hellText}}>Cód. Interno</Text>
              </View>
              { finalList.thirdPage.map((item, index) => (
                <View style={styles.preenchimentoLeft} key={index}>
                  <Text style={styles.preenchimentoLeftText}>{item.codigoInterno ? item.codigoInterno : '-'}</Text>
                </View>
              )) }
            </View>
            <View>
              <View style={{...styles.hellLeft, width: 340}}>
                <Text style={{...styles.hellText}}>Descrição / Apresentação / Qtd Apresentação</Text>
              </View>
              { finalList.thirdPage.map((item, index) => (
                <View style={styles.preenchimentoLeft} key={index}>
                  <Text style={styles.preenchimentoLeftText}>{formatDescricao(item)}</Text>
                </View>
              )) }
            </View>
            <View>
              <View style={{...styles.hell, width: 40}}>
                <Text style={styles.hellText}>Qtd Solicitada</Text>
              </View>
              { finalList.thirdPage.map((item, index) => (
                <View style={styles.preenchimento} key={index}>
                  <Text>{item.quantidade}</Text>
                </View>
              )) }
            </View>
            <View>
              <View style={{...styles.hell, width: 40}}>
                <Text style={styles.hellText}>Qtd atendida</Text>
              </View>
              { finalList.thirdPage.map((item, index) => (
                <View style={styles.preenchimento} key={index}>
                  <Text>{item.quantidadeAtendida}</Text>
                </View>
              )) }
            </View>
          </View>
          <View style={styles.paginacao}>
            <Text style={{ fontSize: 10, textAlign: 'center' }}>3/{finalList.totalPages}</Text>
          </View>
        </Page>
      ) }
    </Document>
  )
}

export default PDFSolicitacaoEmergencial;
